import { ProfileStatus } from "@mimber/schema"

export const PROFILE_STATUS_DISPLAY: Record<
  ProfileStatus,
  { label: string; color: string }
> = {
  [ProfileStatus.DRAFT]: { label: "Draft", color: "default" },
  [ProfileStatus.PUBLISHED]: { label: "Published", color: "green" },
}
